import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import TemplateView from './template';
import BlueRight from '../../../../images/blue-lines-right.svg';
import BlueLeft from '../../../../images/blue-lines-left.svg';
import OrangeLeft from '../../../../images/orange-lines-left.svg';
import { Template } from '../../../../types/working-model';
import { clearWorkingEvent, loadTemplates } from '../../../../store/actions/admin/create-event';
import classNames from 'classnames';
import CollapsingList from '../../../general-ui/collapsing-list/collapsing-list';
import './templates-main.scss';
import EventHeader from '../../header/event-header';
import { useTypedSelector } from '../../../../store/reducers/use-typed-selector';

const TemplatesMain: React.FC = () => {
	const templates = useTypedSelector(state => state.CreateEventReducer.templates);
	const user = useTypedSelector(state => state.AuthReducer.user);
	const token = useTypedSelector(state => state.AuthReducer.token);
	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);

	const dispatch = useDispatch();
	const [viewAll/* , setViewAll */] = useState(false);
	const [filter, setFilter] = useState("Recommended");

	useEffect(() => {
		dispatch(loadTemplates(user!.active_channel, token!));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		// certain edge cases that are hard to replicate were not clearing working event
		// so let's just make sure it's cleared here
		// if workingEvent, clear it
		if (workingEvent) {
			dispatch(clearWorkingEvent());
		}
	}, [workingEvent, dispatch]);

	// function viewAllTemplates() {
	// 	setViewAll(true);
	// 	window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	// }

	const visibleTemplates = useMemo(() => {
		if (viewAll) { return templates; }
		else { return templates?.filter((template: Template, index: number) => index < 3); }
	}, [templates, viewAll]);

	function setSelectedFilter(filter: string) {
		return () => setFilter(filter);
	}

	return (
		<div className="choose-templates-main-wrapper">
			<div>
				<EventHeader
					hideCreateUI
					fullWidth
					showLogo
					linkText="Back to events"
				/>
			</div>
			<div className="wrapper templates" style={{ backgroundImage: `url(${BlueLeft}), url(${OrangeLeft}), url(${BlueRight})` }}>
				<div className="container choose-templates-header">
					<h1 className="ev-heading-2">Get started with recommended templates</h1>
					<p>Choose from a set of beautifully designed best-in-class event templates to make your event stand out.</p>
				</div>
				<div className="template-view-container">

					<div className={classNames("template-container-left", { visible: viewAll })}>
						<label className={classNames("template-filter", { selected: filter === 'Recommended' })}>
							<button onClick={setSelectedFilter('Recommended')}>Recommended</button>
						</label>

						<CollapsingList
							label={"Category"}
							defaultOpen={true}
							maxHeight={200}
							className="template-container-options"
						>
							<ul className="template-type-list">
								<li className={classNames({ selected: filter === 'Virtual Conference' })}>
									<button onClick={setSelectedFilter('Virtual Conference')} className="no-style clear inherit-size">Virtual Conference</button>
								</li>
								<li className={classNames({ selected: filter === 'Product Launch' })}>
									<button onClick={setSelectedFilter('Product Launch')} className="no-style clear inherit-size">Product Launch</button>
								</li>
								<li className={classNames({ selected: filter === 'Summit' })}>
									<button onClick={setSelectedFilter('Summit')} className="no-style clear inherit-size">Summit</button>
								</li>
								<li className={classNames({ selected: filter === 'Political Campaign' })}>
									<button onClick={setSelectedFilter('Political Campaign')} className="no-style clear inherit-size">Political Campaign</button>
								</li>
							</ul>
						</CollapsingList>
						<CollapsingList
							label={"Style"}
							defaultOpen={false}
							maxHeight={200}
							className="template-container-options"
						>
							<ul className="template-type-list">
								<li className={classNames({ selected: filter === 'Hey baby I hear' })}>
									<button onClick={setSelectedFilter('Hey baby I hear')} className="no-style clear inherit-size">Hey baby I hear</button>
								</li>
								<li className={classNames({ selected: filter === 'The blues acalling' })}>
									<button onClick={setSelectedFilter('The blues acalling')} className="no-style clear inherit-size">The blues acalling</button>
								</li>
								<li className={classNames({ selected: filter === 'Tossed salad' })}>
									<button onClick={setSelectedFilter('Tossed salad')} className="no-style clear inherit-size">Tossed salad</button>
								</li>
								<li className={classNames({ selected: filter === 'Scrambled eggs' })}>
									<button onClick={setSelectedFilter('Scrambled eggs')} className="no-style clear inherit-size">Scrambled eggs</button>
								</li>
							</ul>
						</CollapsingList>
					</div>
					<div className={classNames(viewAll ? "template-container-right" : "templates-container-full")}>
						{visibleTemplates?.map((template: Template) => (
							<TemplateView key={template.template} {...template} />
						))}

						{/* Out of scope for MVP: not enough templates to browse more */}
						{/* {!viewAll && (
							<div className="button-row">
								<button onClick={viewAllTemplates}>Browse All</button>
							</div>
						)} */}
					</div>
				</div>
			</div>
		</div>
	);
};

export default TemplatesMain;
